import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TmOutOfOfficeComponent } from '@teammood/shared/ui/out-of-office';
import { TmTimepickerComponent } from "@teammood/shared/ui/timepicker";
import { TmTeamSelectComponent } from '@teammood/team';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { TmPipesModule } from '../shared/util/pipes';
import { MatTabsModule } from '@angular/material/tabs';
import { PollPreviewComponent } from './create-poll/poll-preview/poll-preview.component';
import { PollTemplateElementComponent } from './poll-templates/poll-template-element/poll-template-element.component';
import { UserPollsComponent } from './user-polls/user-polls.component';
import { PollsSetupComponent } from './polls-setup.component';
import { PollTemplatesComponent } from './poll-templates/poll-templates.component';
import { MatDialogModule } from '@angular/material/dialog';
import {
  PollResultCommentsComponent
} from '../timeline/timeline-item/poll-result/poll-result-comments/poll-result-comments.component';
import { PollResultsChartComponent } from './user-polls/poll-results-chart/poll-results-chart.component';
import {
  SendPollReminderDialogComponent
} from './user-polls/send-poll-reminder-dialog/send-poll-reminder-dialog.component';
import { RouterLink } from "@angular/router";
import { MakePollRecurrentDialogComponent } from './user-polls/make-poll-recurrent-dialog/make-poll-recurrent-dialog.component.ts';
import { PollResultsDialogComponent } from './user-polls/poll-results-dialog/poll-results-dialog.component';
import { TrendPollResultsDialogComponent } from './user-polls/trend-poll-results-dialog/trend-poll-results-dialog.component';
import { RecurringClosedPollResultTrendsChartComponent } from '../timeline/timeline-item/poll-result/recurring/recurring-closed-poll-result-trends-chart/recurring-closed-poll-result-trends-chart.component';
import { RecurringPollResultTrendsLineChartComponent } from '../timeline/timeline-item/poll-result/recurring/recurring-poll-result-trends-line-chart/recurring-poll-result-trends-line-chart.component';
import {
  RecurringPollResultTrendsComponent
} from "../timeline/timeline-item/poll-result/recurring/recurring-poll-result-trends.component";
import { TmSlideToggleComponent } from '../shared/ui/slide-toggle/slide-toggle.component';
import { TeamChipListComponent } from '../taskbook-backlog/team-chip-list/team-chip-list.component';
import { PollTaskDetailsOccurenceListComponent } from '../taskbook-backlog/task-details/poll-task-details-occurrence-list/poll-task-details-occurrence-list.component';
import { UserPollOccurenceComponent } from './user-polls/user-poll-occurrence/user-poll-occurrence.component';
import { UserPollOccurenceListComponent } from './user-polls/user-poll-occurrence-list/user-poll-occurrence-list..component';

@NgModule({
  declarations: [
    PollsSetupComponent,
    UserPollsComponent,
    PollTemplatesComponent,
    PollTemplateElementComponent,
    PollResultsDialogComponent,
    SendPollReminderDialogComponent,
    ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    TmOutOfOfficeComponent,
    OverlayModule,
    ReactiveFormsModule,
    TmTimepickerComponent,
    TmTeamSelectComponent,
    MakePollRecurrentDialogComponent,
    TmSlideToggleComponent,
    MatMenuModule,
    MatTooltip,
    PollPreviewComponent,
    TmPipesModule,
    MatTabsModule,
    MatDialogModule,
    PollResultsChartComponent,
    PollResultCommentsComponent,
    RouterLink,
    RecurringClosedPollResultTrendsChartComponent,
    RecurringPollResultTrendsLineChartComponent,
    RecurringPollResultTrendsComponent,
    TranslateModule,
    TrendPollResultsDialogComponent,
    TeamChipListComponent,
    PollTaskDetailsOccurenceListComponent,
    UserPollOccurenceListComponent,
    UserPollOccurenceComponent
  ]
})
export class TmPollSetupModule{
}